import { z } from "zod";
import { horaInicioSchema } from "../../plantoes/schemas/plantaoSchema";
import { VINCULO_COLOR_KEYS } from "../utils/vinculoColors";

// Mesmo limite do backend (domain.MaxEndereco).
export const ENDERECO_MAX = 300;

export const vinculoSchema = z.object({
  nome: z.string().min(2, "Informe o nome do hospital/tomador"),
  tipo: z.enum(["privado", "cooperativa", "organizacao_social", "prefeitura_os"], {
    errorMap: () => ({ message: "Escolha o tipo do vínculo" }),
  }),
  cnpj: z.string().optional().or(z.literal("")),
  valorPlantao: z.coerce.number({ invalid_type_error: "Informe o valor" }).positive("O valor deve ser maior que zero"),
  // Opcional: vazio = mesmo valor todos os dias (null para o backend).
  valorFimDeSemana: z.preprocess(
    (value) => (value === "" || value === undefined ? null : value),
    z.coerce.number({ invalid_type_error: "Informe um valor válido" }).positive("O valor deve ser maior que zero").nullable()
  ),
  horasPlantao: z.coerce.number({ invalid_type_error: "Informe a duração" }).positive("A duração deve ser maior que zero").max(24, "A duração máxima é 24 horas"),
  diaPagamento: z.coerce.number().int().min(1, "Entre 1 e 31").max(31, "Entre 1 e 31"),
  diaLimiteNF: z.coerce.number().int().min(1, "Entre 1 e 31").max(31, "Entre 1 e 31"),
  horaInicioPadrao: horaInicioSchema.default(""),
  // Vazio = deixa o backend escolher a próxima cor livre (só no cadastro).
  cor: z.enum(VINCULO_COLOR_KEYS).or(z.literal("")).default(""),
  endereco: z.string().trim().max(ENDERECO_MAX, `O endereço pode ter até ${ENDERECO_MAX} caracteres`).default(""),
});
